exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.open-up-cancelation-reason .dropdown-menu {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  transform: translateY(-100%);\n  min-height: 200px;\n}\n.v-select.open-up-cancelation-reason.open .dropdown-toggle {\n  border-top-color: transparent;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-color: #DBDFE2;\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-5b8996f1","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/modal/EventEdit/areaDetails.vue
// module id = 1349
// module chunks = 0